import { render, staticRenderFns } from "./serviceProvider.vue?vue&type=template&id=39670f9c&"
import script from "./serviceProvider.vue?vue&type=script&lang=ts&"
export * from "./serviceProvider.vue?vue&type=script&lang=ts&"
import style0 from "./serviceProvider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports